/***
 * Created on 2023/8/30
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiPut} from "../../../../../service/api";
import {getLocalUser} from "../../../../../service/user";

function DisableTwoStep({dispatch, ...prop}) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const activateMutate = useMutation({
        mutationFn: async (data) => await apiPut(`/ajax/activate_two_step`, data),
        onSuccess: data => {
            console.log(data);
            // queryClient.invalidateQueries({
            //     queryKey: ['profile']
            // })
            let user = getLocalUser();
            let secure = {
                two_step_enabled: false
            }
            if (user.secure?.qnap_auth) {
                secure.qnap_auth = user.secure.qnap_auth
            }
            user.secure = secure;
            localStorage.setItem('currentUser', JSON.stringify(user));
            dispatch({type: 'toggleSigninAgain', value: true});
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onDisable = async () => {
        const data = {
            two_step_enabled: false
        }
        await activateMutate.mutateAsync(data);
    }

    return (
        <ModalDialog {...prop} title={t('@Disable 2-step verification@')} submitText={t('@Disable@')} submitAction={onDisable}>
            <div className="dialog-content">
                <p>
                    {t('@Disabling 2-Step Verification will remove the TOTP profile associated with your account. You will no longer have access to additional authentication methods provided by QNAP Authenticator when signing in from an untrusted device. Removing this extra layer of security increases the risk to your account.@')}
                </p>
            </div>
        </ModalDialog>
    );
}

export default DisableTwoStep;